import React, { Component, } from 'react'
import { AssessmentReport, } from '../../components/Assessment/AssessReport'
import firebase from 'firebase'
import { db } from '../../config/firebaseconfig'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as assessmentActionCreators from '../../redux/modules/assessment'
import * as manageEducatorsActionCreators from '../../redux/modules/manageEducators'
import has from 'mout/object/has'
import newSubtestReport from '../../helpers/assessment/newSubtestReport'
import saveSubtestReport from '../../helpers/assessment/saveSubtestReport';
import districtAdmin from '../../helpers/users/testing/districtAdmin';
import teacherUser from '../../helpers/users/testing/teacherUser';
import fetchGroupUAsPromise from '../../helpers/assessment/fetchGroupUAsPromise'
import initializeManageEducators from '../../helpers/users/initializeManageEducators';
import getGroupType from '../../helpers/assessment/getGroupType';
import computeGroupUA from '../../helpers/assessment/computeGroupUA';
import studentUser from '../../helpers/users/testing/studentUser';
import queryString from 'query-string'
import getSchoolYear from '../../helpers/getSchoolYear'
import requestGroupUAUpdate from '../../helpers/assessment/requestGroupUAUpdate';
import guaNeedsUpdateQ from '../../helpers/assessment/guaNeedsUpdateQ';
import processGroupUAUpdate from '../../helpers/assessment/processGroupUAUpdate';
import isLicenseExpired from '../../helpers/users/licenses/isLicenseExpired'
import schoolYearDataIndicator from '../../helpers/schoolYearDataIndicator';
import { setIndicator } from '../../redux/modules/assessmentIndicator'
import LoaderAssessmentDashboardContainer from "../../containers/Assessment/LoaderAssessmentDashboardContainer";

/**
 * Container for AssessmentReport, found on the
 * /assessment/reports/ route. Displays all the
 * skill performance for each subject.
 */

class AssessmentReportContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      // user: studentUser,
      // user: districtAdmin,
      user: teacherUser,
      updatingGUA: false,
    }

    this.selectGroupUA = this.selectGroupUA.bind(this)
    this.selectStudent = this.selectStudent.bind(this)
  }

  initTestSelector(assessmentId, selectedStudent, selectedGroupUA){
    const { groupUAs, students, userLicenses } = this.props;
    const testId = queryString.parse(this.props.location.search).a
    const actions = {
      setIndicator: this.props.setIndicator
    }
    schoolYearDataIndicator(
      assessmentId, 
      selectedStudent, 
      selectedGroupUA,
      actions, 
      groupUAs, 
      students, 
      userLicenses, 
      testId
      )
  }

  // Selects a new data group when the user selects a new
  // grouping with the selector bar.
  selectGroupUA(groupUA) {
    const subtest = this.props.match.params.subTestSetId
    const assessmentId = queryString.parse(this.props.location.search).a
    let year = queryString.parse(this.props.location.search).y 
    this.props.history.push(`/assessment/reports/${groupUA}/${subtest}?g=true&a=${assessmentId}`)
    // const { districts, schools, educators, classes, selectedYear } = this.props
    // if (districts && schools && educators && classes) {
    //   const groupData = { districts, schools, educators, classes, }
    //   const groupType = getGroupType(groupUA, groupData)
    //   const year = selectedYear ? selectedYear : getSchoolYear().year
    //   computeGroupUA(groupUA, groupType, groupData, assessmentId, year)

    const { districts, schools, educators, classes, groupUAs, fetchingGroupUAsSuccess } = this.props
    if (districts && schools && educators && classes) {
      const groupData = { districts, schools, educators, classes, }
      const groupType = getGroupType(groupUA, groupData)
      year = year ? year : getSchoolYear().year
      if (groupUAs) {
        let groupUAObj
        if (groupUAs[groupUA] && groupUAs[groupUA][year]) {
          groupUAObj = groupUAs[groupUA][year][assessmentId]
          this.initTestSelector(null, null, groupUA)
        }
        if (guaNeedsUpdateQ(groupUAObj) || !groupUAObj) {
          this.setState({updatingGUA: true})
          let schoolYear = Number(year.split('sy')[1])
          requestGroupUAUpdate(groupUA, assessmentId, schoolYear)
            .then(result => {
              // let GUAs = groupUAs
              // if (result) {
              //   const GUA = JSON.parse(result)
              //   GUAs = {
              //     ...groupUAs,
              //     [groupUA]: GUA,
              //   }   
              // }
              // this.setState({updatingGUA: false})
              // fetchingGroupUAsSuccess(GUAs)
              const actions = {
                fetchingGroupUAsSuccess, 
                updateState: this.setState.bind(this)
              }
              processGroupUAUpdate(result, groupUAs, groupUA, schoolYear, assessmentId, actions)
            })
            .catch(err => {
              console.log(err)
              this.setState({updatingGUA: false})
            })
        }
      }
    }
    this.initGroupUA(groupUA)
  }

  // initializes everything needed to display the groupUA.
  // groupUA is the object that summarizes all of the 
  // userAssessments in a given group.
  initGroupUA(groupUAId, studentId) {
    const testUser = this.props.user || this.state.user

    let qs, isGroup, assessmentId
    if (this.props.location.search) {
      qs = queryString.parse(this.props.location.search)
      isGroup = qs.g
      assessmentId = qs.a
    }
    const selectedGroupUA = groupUAId || this.props.match.params.userAssessmentId
    const subtestId = this.props.match.params.subTestSetId
    let promises = []
    let getGroupUAs, getNodes

    // get groupUAs if haven't already
    if (!this.props.groupUAs) {
      const actions = {
        fetching: this.props.fetchingGroupUAs,
        success: this.props.fetchingGroupUAsSuccess,
        error: this.props.fetchingGroupUAsError,
        push: this.props.history.push,
      }
      getGroupUAs = fetchGroupUAsPromise(testUser, assessmentId, actions, selectedGroupUA)
      promises.push(getGroupUAs)
    }

    // Get knowledge map nodes if haven't already.
    // These provide us the skill heirarchy.
    if (!this.props.nodes) {
      getNodes = db.collection('knowledgeMapNodes').get()
        .then((querySnapshot) => {
          let nodes = {}
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            nodes[data.id] = data
          })
          this.props.fetchingNodesSuccess(nodes)
          return nodes
        })
      promises.push(getNodes)
    }

    Promise.all(promises)
      .then((results) => {
        let nodes, groupUAs
        if (getGroupUAs && !getNodes) {
          groupUAs = results[0]
          nodes = this.props.nodes
        } else if (getGroupUAs && getNodes) {
          groupUAs = results[0]
          nodes = results[1]
        } else if (!getGroupUAs && getNodes) {
          nodes = results[0]
          groupUAs = this.props.groupUAs
        } else {
          nodes = this.props.nodes
          groupUAs = this.props.groupUAs
        }
        if (!studentId) {
          let GUA = null
          let year = queryString.parse(this.props.location.search).y
          // const { selectedYear } = this.props
          if (groupUAs[selectedGroupUA]) {
            GUA = groupUAs[selectedGroupUA][year ? year : getSchoolYear().year][assessmentId]
          }
          if (GUA) {
            if (GUA.scoring.byNode[subtestId]) {
              const newReport = newSubtestReport(GUA.scoring, GUA.assessmentSubtests[subtestId], nodes, GUA.assessmentSet.maxNodeLevels)
              this.props.setSubtestReport(newReport)
            } else {
              this.props.setSubtestReport(null)
            }
          } else {
            this.props.setSubtestReport(null)
          }
        } else {
          console.log(studentId, assessmentId)
          this.getStudentUserAssessment(studentId, assessmentId)
        }

      })
      .catch((err) => this.props.fetchingNodesError(err))
  }


  initComponent(nextProps) {
    const props = nextProps ? nextProps : this.props
    props.fetchingSubtestReportSuccess(null) //clears subtest so loading indicator works
    const testUser = props.user || this.state.user

    // check to see if the userAssessment object already has a report
    const userAssessmentId = props.match.params.userAssessmentId
    const subtestId = props.match.params.subTestSetId
    
    let newReport
    let isGroup, studentId, assessmentId
    if (props.location.search) {
      const qs = queryString.parse(props.location.search)
      isGroup = qs.g
      studentId = qs.s
      assessmentId = qs.a
    }
    // If we are looking at a group's data, we need to
    // run initializeManageEducators
    if (isGroup) {
      if (studentId && assessmentId) {
        this.initGroupUA(null, studentId)
      } else {
        this.initGroupUA()
      }
      if (testUser.role !== 'Student') {
        const initActions = {
          initializing: props.initializing,
          initializingError: props.initializingError,
          initializingSuccess: props.initializingSuccess,
          set: {
            districts: props.setDistricts,
            schools: props.setSchools,
            educators: props.setEducators,
            students: props.setStudents,
            classes: props.setClasses,
          }
        }
        initializeManageEducators(testUser, initActions)
      }
      // Otherwise, we're looking at one student's data,
      // so we need to create that student's report.
    } else if (!props.userAssessment) {
      props.assessmentInitialize()
      db.collection('userAssessments').doc(userAssessmentId).get()
        .then((doc) => {
          if (doc.exists) {
            const userAssessment = doc.data()
            props.assessmentInitializeSuccess(userAssessment)

            // if has(userAssessment, `reports.${subtestId}`) then get the subtestReport and we're good to go!
            // if (has(userAssessment, `reports.${subtestId}`)) {
            //   // get the subtestReport
            //   const reportId = Object.keys(userAssessment.reports[subtestId])[0]
            //   props.fetchingSubtestReport()
            //   db.collection('subtestReports').doc(reportId).get()
            //     .then((doc) => {
            //       doc.exists
            //         ? props.fetchingSubtestReportSuccess(doc.data())
            //         : props.fetchingSubtestReportError('subtestReport not found in db')
            //     })
            //     .catch((err) => props.fetchingSubtestReportError(err))
            // } else {
              // if not, then pull nodes and generate a subtestReport
              if (!props.nodes) {
                props.fetchingNodes()
                db.collection('knowledgeMapNodes').get()
                  .then((querySnapshot) => {
                    let nodes = {}
                    querySnapshot.forEach((doc) => {
                      const data = doc.data()
                      nodes[data.id] = data
                    })
                    props.fetchingNodesSuccess(nodes)
                    if (!userAssessment.assessmentSubtests[subtestId]) {
                      props.history.push('/assessment/not-found')
                    } else {
                      newReport = newSubtestReport(userAssessment.scoring, userAssessment.assessmentSubtests[subtestId], nodes, userAssessment.assessmentSet.maxNodeLevels)
                      saveSubtestReport(newReport, subtestId, userAssessment, props.setSubtestReport)
                    }
                  })
                  .catch((err) => props.fetchingNodesError(err))
              } else {
                newReport = newSubtestReport(userAssessment.scoring, userAssessment.assessmentSubtests[subtestId], props.nodes, userAssessment.assessmentSet.maxNodeLevels)
                saveSubtestReport(newReport, subtestId, userAssessment, props.setSubtestReport)
              }
            // }
          } else {
            props.assessmentInitializeError('userAssessment on Route Not Found')
            props.history.push('/assessment/not-found')
          }
        })
        .catch((err) => props.assessmentInitializeError(err))
    } else {
      if (has(props.userAssessment, `reports.${subtestId}`)) {
        // get the subtestReport
        const reportId = Object.keys(props.userAssessment.reports[subtestId])[0]
        props.fetchingSubtestReport()
        db.collection('subtestReports').doc(reportId).get()
          .then((doc) => {
            doc.exists
              ? props.fetchingSubtestReportSuccess(doc.data())
              : props.fetchingSubtestReportError('subtestReport not found in db')
          })
          .catch((err) => props.fetchingSubtestReportError(err))
      } else {
        if (!props.nodes) {
          props.fetchingNodes()
          db.collection('knowledgeMapNodes').get()
            .then((querySnapshot) => {
              let nodes = {}
              querySnapshot.forEach((doc) => {
                const data = doc.data()
                nodes[data.id] = data
              })
              props.fetchingNodesSuccess(nodes)
              newReport = newSubtestReport(props.userAssessment.scoring, props.userAssessment.assessmentSubtests[subtestId], nodes, props.userAssessment.assessmentSet.maxNodeLevels)
              saveSubtestReport(newReport, subtestId, props.userAssessment, props.setSubtestReport)
            })
            .catch((err) => props.fetchingNodesError(err))
        } else {
          newReport = newSubtestReport(props.userAssessment.scoring, props.userAssessment.assessmentSubtests[subtestId], props.nodes, props.userAssessment.assessmentSet.maxNodeLevels)
          saveSubtestReport(newReport, subtestId, props.userAssessment, props.setSubtestReport)
        }
      }
    }
  }

  // Allows user to switch between one student and another
  // using the selector bar.
  selectStudent(studentId) {
    const groupUAId = this.props.match.params.userAssessmentId
    const subtestId = this.props.match.params.subTestSetId
    const qs = queryString.parse(this.props.location.search)
    const assessmentId = qs.a
    const newQS = {
      ...qs,
      s: studentId
    }
    const query = queryString.stringify(newQS)
    this.props.history.push(`/assessment/reports/${groupUAId}/${subtestId}?${query}`)
    this.getStudentUserAssessment(studentId, assessmentId)
    this.initTestSelector(null, studentId)
  }

  // Fetches the userAssessment for the selected student.
  getStudentUserAssessment(studentId, assessmentId, year) {
    // get user doc, then get uA and nodes, then generate report
    const subtestId = this.props.match.params.subTestSetId
    
    let schoolYear = year ? year : getSchoolYear().year;

    db.collection('students').doc(studentId).get()
      .then((doc) => {
        const student = doc.data();
        if (student && student.assessments && student.assessments[assessmentId]) {
          const userAssessmentId = student.assessments[assessmentId];
          //for new student assessment db stucture by school year
          if(userAssessmentId.hasOwnProperty(schoolYear)) {
            return doc.data().assessments[assessmentId][schoolYear].userAssessmentId
          } else {
            //for old db structure
            return student.assessments[assessmentId].userAssessmentId
          }
        }
      })
      .then((userAssessmentId) => {
        let promises = []
        this.props.assessmentInitialize()
        const getUserAssessment = db.collection('userAssessments').doc(userAssessmentId).get()
          .then((uAdoc) => {
            this.props.assessmentInitializeSuccess(uAdoc.data())
            return uAdoc.data()
          })
        promises.push(getUserAssessment)

        if (!this.props.nodes) {
          this.props.fetchingNodes()
          const getNodes = db.collection('knowledgeMapNodes').get()
            .then((querySnapshot) => {
              let nodes = {}
              querySnapshot.forEach((doc) => {
                const data = doc.data()
                nodes[data.id] = data
              })
              this.props.fetchingNodesSuccess(nodes)
              return nodes
            })
          promises.push(getNodes)
        }

        Promise.all(promises)
          .then((results) => {
            const uA = results[0]
            const nodes = this.props.nodes || results[1]
            if (uA.scoring.byNode[subtestId]) {
              const newReport = newSubtestReport(uA.scoring, uA.assessmentSubtests[subtestId], nodes, uA.assessmentSet.maxNodeLevels)
              this.props.setSubtestReport(newReport)
            } else {
              this.props.setSubtestReport(null)
            }
          })
          .catch((err) => this.props.assessmentInitializeError(err))
      })
  }

  componentDidMount() {
    this.initComponent()
  }

  // Confirms that we're ready to calculate a groupUA. If we are,
  // then it calls computeGroupUA. computeGroupUA creates a new 
  // groupUA in the database or refreshes an existing. This gets called when 
  // the query in the URL changes. It's important to compute the groupUA
  // before looking at it to make sure we're incorporating any new
  // student data.
  validateGroupUA(nextProps) {
    const { districts, schools, educators, classes, groupUAs, fetchingGroupUAsSuccess } = this.props
    const n = nextProps
    // Were we missing data about districts, schools, educators,
    // or classes, and do we have it all now? If so, compute the
    // groupUA.
    const thisCheck = (!!districts && !!schools && !!educators && !!classes)
    const nextCheck = (!!n.districts && !!n.schools && !!n.educators && !!n.classes)
    if ((thisCheck !== nextCheck) && nextCheck) {
      const qs = queryString.parse(n.location.search)
      const groupUA = this.props.match.params.userAssessmentId
      if (groupUA && qs.g) {
        const groupData = {
          districts: n.districts,
          schools: n.schools,
          educators: n.educators,
          classes: n.classes,
        }
        const groupType = getGroupType(groupUA, groupData)
        const year = qs.y ? qs.y : getSchoolYear().year
        const assessmentId = qs.a
        if (groupUAs) {
          let groupUAObj
          if (groupUAs[groupUA] && groupUAs[groupUA][year]) {
            groupUAObj = groupUAs[groupUA][year][assessmentId]
          }
          if (guaNeedsUpdateQ(groupUAObj) || !groupUAObj) { 
            this.setState({updatingGUA: true})
            const schoolYear = Number(year.split('sy')[1])
            requestGroupUAUpdate(groupUA, assessmentId, schoolYear)
              .then(result => {
                // let GUAs = groupUAs
                // if (result) {
                //   const GUA = JSON.parse(result)
                //   GUAs = {
                //     ...groupUAs,
                //     [groupUA]: GUA,
                //   }   
                // }
                // this.setState({updatingGUA: false})
                // fetchingGroupUAsSuccess(GUAs)
                const actions = {
                  fetchingGroupUAsSuccess,
                  updateState: this.setState.bind(this)
                }
                processGroupUAUpdate(result, groupUAs, groupUA, schoolYear, assessmentId, actions)
              })
              .catch(err => {
                console.log(err)
                this.setState({updatingGUA: false})
              })
          }
        }
        // computeGroupUA(groupUA, groupType, groupData, assessmentId, year, fetchingGroupUAsSuccess, groupUAs)
      }
    }
  }

  // componentWillReceiveProps(nextProps) {
  //   this.validateGroupUA(nextProps)
  //   if (this.props.match.params.subTestSetId !== nextProps.match.params.subTestSetId) {
  //     this.initComponent(nextProps)
  //   }
  // }

  componentDidUpdate(prevProps) {
    const { assessmentIndicator, location, user } = this.props;
    const { selectedOption } = assessmentIndicator;

    this.validateGroupUA(this.props)

    if (prevProps.match.params.subTestSetId !== this.props.match.params.subTestSetId) {
      this.initComponent(this.props)
    }

    if (prevProps.assessmentIndicator.selectedOption !== selectedOption) {
      if (selectedOption) {
        const { year, userAssessmentId, gua, student, testId } = selectedOption;
        const qs = queryString.parse(location.search);

        if(has(qs, 's')){
          this.getStudentUserAssessment(student, testId, year)

        } 
        if(user && has(user, 'role') && user.role === 'Student'){
          this.getStudentUserAssessment(student, testId, year)
        }
      }
    }
  }

  render() {
    const {
      assessmentInitializingError,
      isAssessmentInitializing,
      manageEducatorsError,
      isInitializing,
      isFetchingNodes,
      isFetchingGroupUAs,
      currentAssessmentId,
      compareAssessmentId,
      isCompare,
      compareGuaYear
     } = this.props
     const { updatingGUA } = this.state
     let test1 = this.props.state.assessment.currentAssismentName;
     let test2 = this.props.state.assessment.compareAssismentName;

    let subtestId = this.props.match.params.subTestSetId;
    const testUser = this.props.user || this.state.user;
    let groupUA = null;
    let assessmentId;
    let qs = {};
    if (this.props.location.search) {
      qs = queryString.parse(this.props.location.search)
    }
    let year = qs.y ? qs.y : getSchoolYear().year

    let selectedStudent = ''
    let selectedGroupUA = ''
    if (testUser.role !== 'Student' && this.props.groupUAs) {

      assessmentId = qs.a

      selectedGroupUA = this.props.match.params.userAssessmentId
      if (this.props.groupUAs[selectedGroupUA]) {
        if(has(this.props.groupUAs[selectedGroupUA], year)) {
          groupUA = this.props.groupUAs[selectedGroupUA][year][assessmentId]
        } 
      }
    }
let groupUACompare = ''
    if (testUser.role !== 'Student' && this.props.groupUAs) {
      selectedGroupUA = this.props.match.params.userAssessmentId
      if (this.props.groupUAs[selectedGroupUA]) {
        if (compareGuaYear && compareAssessmentId && has(this.props.groupUAs[selectedGroupUA], compareGuaYear)) {
          groupUACompare = this.props.groupUAs[selectedGroupUA][compareGuaYear][compareAssessmentId]
        }
      }
    }


    if (testUser.role === 'Student' && this.props.userAssessment) {
      assessmentId = this.props.userAssessment.assessmentSetId
    }

    const { districts, schools, educators, classes, students, user } = this.props
    const groupData = {
      districts,
      schools,
      educators,
      classes,
      students,
    }

    if (qs.s) {
      selectedStudent = qs.s
    }
    const loadingError = !!( Object.keys(assessmentInitializingError).length || Object.keys(manageEducatorsError).length )
    const initializing = !!(isInitializing || isFetchingNodes || isFetchingGroupUAs)
    return (!this.state.updatingGUA ? 
      <AssessmentReport
        query={qs}
        a = {qs.a}
        s = {qs.s}
        nd = {qs.node}
        state = {this.props.state}
        isCompare = {isCompare}
        routeParams={this.props.match.params}
        userAssessment={this.props.userAssessment}
        userAssessmentCompare={this.props.userAssessmentCompare}
        currentAssessmentId = {this.props.currentAssessmentId}
        compareAssessmentId = {this.props.compareAssessmentId}
        nodes={this.props.nodes}
        subtestId={subtestId}
        subtestReport={this.props.subtestReport}
        user={testUser}
        groupUA={groupUA}
        groupUACompare={groupUACompare}
        groupData={groupData}
        assessmentId={assessmentId ? assessmentId : ''}
        groupUAs={this.props.groupUAs}
        selectGroupUA={this.selectGroupUA}
        selectedStudent={selectedStudent}
        selectStudent={this.selectStudent}
        selectedGroupUA={selectedGroupUA}
        loadingError={loadingError}
        isFetchingGroupUAs={this.props.isFetchingGroupUAs}
        initializing={initializing}
        year={year}
        updatingGUA={updatingGUA}
        test1 = {test1}
        test2 = {test2}
        isSwap = {this.props.state.assessment.isSwap}
      /> : <LoaderAssessmentDashboardContainer user={user} />
    )
  }
}

export default connect(
  (state) => ({
    userAssessment: state.assessment.userAssessment,
    userAssessmentCompare: state.assessment.compareAssismentData,
    state : state ,
    isCompare : state.assessment.isCompare,
    assessmentId : state.assessment.assessmentId ,
    currentAssessmentId : state.assessment.currentAssismentId,
    compareAssessmentId : state.assessment.compareAssismentId,
    nodes: state.assessment.nodes,
    subtestReport: state.assessment.subtestReport,
    groupUAs: state.assessment.groupUAs,
    isFetchingGroupUAs: state.assessment.isFetchingGroupUAs,
    selectedGroupUA: state.assessment.selectedGroupUA,
    GUAFilter: state.assessment.GUAFilter,
    districts: state.manageEducators.districts,
    schools: state.manageEducators.schools,
    educators: state.manageEducators.educators,
    classes: state.manageEducators.classes,
    students: state.manageEducators.students,
    user: state.users.testUser,
    assessmentInitializingError: state.assessment.assessmentInitializingError,
    manageEducatorsError: state.manageEducators.error,
    isCompare:state.assessment.isCompare,
    isInitializing: state.manageEducators.isInitializing,
    isFetchingNodes: state.assessment.isFetchingNodes,
    selectedYear: state.users.selectedYear,
    assessmentIndicator: state.assessmentIndicator,
    userLicenses: state.licenses.userlicenses,
    compareGuaYear: state.assessment.compareGuaYear
    
  }),
  (dispatch) => bindActionCreators({ ...assessmentActionCreators, ...manageEducatorsActionCreators, setIndicator }, dispatch)
)(AssessmentReportContainer)


// WEBPACK FOOTER //
// ./src/containers/Assessment/AssessmentReportContainer.js